exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".img-crop-container[data-v-b011c2d8] {\n  max-width: 600px;\n  max-height: 600px;\n}\n.img-crop-container[data-v-b011c2d8] img {\n  max-width: 600px;\n  max-height: 600px;\n}\n", ""]);

